import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const theme = {
  config: {
    intialColorMode: "dark",
    useSystemColorMode: true,
  },
  colors: {
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    orange: {
      primary: "#FE9203",
      secondary: "#c48531",
    },
    blue: {
      primary: "#212138",
      secondary: "#1A365D",
      tertiary: "#191930",
    },
    white: {
      primary: "#EDFDFD",
      secondary: "#b4b4b4",
    },

    bg: {
      light: "#EDFDFD",
      dark: "#212138",
    },

    _hover: {
      light: "",
      dark: "",
    },
  },
  breakpoints: {
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode("bg.light", "bg.dark")(props),
        fontFamily: "sans-serif",
        // fontFamily: "'Montserrat', sans-serif",
      },
    }),
  },
  components: {
    Drawer: {
      parts: ["dialog", "header", "body"],
      variants: {
        primary: {
          dialog: {
            background: "blue.tertiary",
            maxW: { base: "100%", md: "50%" },
          },
        },
        secondary: {
          dialog: {
            background: "bg.light",
          },
        },
      },
    },
  },
};

export default extendTheme(theme);
